import { useState } from '@frontend/react';
import { Text, XStack, YStack } from '@frontend/web-react';
import { TextInput } from '..';

import type { MakeInputProps } from '@frontend/forms';

type BirthdayInputProps = MakeInputProps<
  MaybeUndefined<DateISOString>,
  {
    error?: string;
  }
>;

export const BirthdayInput = ({
  error,
  label = 'Birthday',
  onBlur,
  onChange,
  value: birthdayFromForm,
}: BirthdayInputProps) => {
  const [birthday, setBirthday] = useState({
    day: birthdayFromForm?.split('-')[2] || '',
    month: birthdayFromForm?.split('-')[1] || '',
    year: birthdayFromForm?.split('-')[0] || '',
  });

  const handleBirthdayChange = (field: 'day' | 'month' | 'year', value: string) => {
    setBirthday((prev) => ({ ...prev, [field]: value }));

    const [formattedYear, formattedMonth, formattedDay] = birthdayFromForm?.split('-') || [];

    const updatedDate = {
      day: field === 'day' ? value.padStart(2, '0') : formattedDay,
      month: field === 'month' ? value.padStart(2, '0') : formattedMonth,
      year: field === 'year' ? value : formattedYear,
    };

    onChange(`${updatedDate.year}-${updatedDate.month}-${updatedDate.day}` as DateISOString);
  };

  return (
    <YStack gapY="sm">
      <Text>{label}</Text>
      <XStack gapX="sm">
        <TextInput
          label="Month"
          labelProps={{ textProps: { type: 'p-sm' } }}
          maxLength={2}
          onBlur={onBlur}
          onChange={(value) => handleBirthdayChange('month', value)}
          placeholder="MM"
          value={birthday.month}
        />
        <TextInput
          label="Day"
          labelProps={{ textProps: { type: 'p-sm' } }}
          maxLength={2}
          onBlur={onBlur}
          onChange={(value) => handleBirthdayChange('day', value)}
          placeholder="DD"
          value={birthday.day}
        />
        <TextInput
          label="Year"
          labelProps={{ textProps: { type: 'p-sm' } }}
          maxLength={4}
          onBlur={onBlur}
          onChange={(value) => handleBirthdayChange('year', value)}
          placeholder="YYYY"
          value={birthday.year}
        />
      </XStack>
      {error ? (
        <Text color="danger" type="caption">
          {error}
        </Text>
      ) : null}
    </YStack>
  );
};
